// Logo — three-dot Harness mark with criss-cross strokes. The only custom
// glyph in the system. Background is a 135° gradient from the user's accent
// to a fixed magenta (308°), per Harness DS v1.0.

interface Props {
  /** Outer square edge length in px. Default 22 (TopBar). 26 for sidebar/dialog. */
  size?: number;
  /** Inner SVG glyph size (defaults to size − 9). */
  glyph?: number;
  className?: string;
}

export default function Logo({ size = 22, glyph, className = "" }: Props) {
  const inner = glyph ?? Math.round(size * 0.59);
  const radius = size <= 22 ? 6 : 7;
  return (
    <span
      aria-hidden
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background:
          "linear-gradient(135deg, var(--accent), var(--accent-magenta))",
      }}
    >
      <svg
        width={inner}
        height={inner}
        viewBox="0 0 16 16"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <circle cx="4" cy="4" r="1.6" />
        <circle cx="12" cy="4" r="1.6" />
        <circle cx="8" cy="12" r="1.6" />
        <path d="M5.2 5l2 5.5M10.8 5l-2 5.5M5 4h6" />
      </svg>
    </span>
  );
}
